<section class="flex-col justify-center align-center">
  <mat-card>
    <div class="flex-col justify-center align-center">
      <h3>Welcome to the TERPECA Voter Portal!</h3>
      <img src="assets/toproomslogo.png" height="150px" width="150px">
    </div>
    <div>
      <p>
        We are looking for the world's most experienced escape room
        enthusiasts to help identify the world's best escape rooms.
        If that sounds like you, you came to the right place!
      </p>
      <p>
        To get started, or to sign in to an existing account*, select one of
        the sign-in options below.
      </p>
      <p>
        If you want to learn more first, start with the <a routerLink="/faq">FAQ</a> or
        you can watch our <a href="https://www.youtube.com/watch?v=juX7x-2gOhU" target="_blank">How to Apply</a>
        video which will walk you through the application process.
        If something isn't working, <a routerLink="/contact" [queryParams]="{category: 'technical-issue'}">contact us</a>.
      </p>
    </div>
    <div class="login-auth">
      @if (!showEmailLinkForm) {
        <ul class="login-idp-list">
          <li>
            <button
              type="button"
              class="login-idp-button login-idp-password"
              [disabled]="providerBusy"
              (click)="startEmailLinkSignIn()">
              <span class="login-idp-icon-wrapper" aria-hidden="true">
                <img
                  class="login-idp-icon"
                  alt=""
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg">
              </span>
              <span class="login-idp-text">Sign in with email</span>
            </button>
          </li>
          <li>
            <button
              type="button"
              class="login-idp-button login-idp-google"
              [disabled]="providerBusy"
              (click)="signInWithGoogle()">
              <span class="login-idp-icon-wrapper" aria-hidden="true">
                <img
                  class="login-idp-icon"
                  alt=""
                  src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg">
              </span>
              <span class="login-idp-text">Sign in with Google</span>
            </button>
          </li>
        </ul>
        @if (providerError) {
          <div class="login-provider-error">{{ providerError }}</div>
        }
      } @else {
        <div class="login-email">
          @if (!completingEmailLink) {
            <button type="button" class="login-back" (click)="cancelEmailLinkSignIn()">
              ← Back
            </button>
          }
          @if (emailLinkError) {
            <div class="login-provider-error">{{ emailLinkError }}</div>
          }
          <!-- The library form also completes the link from its constructor, so keep it
               unmounted while ours runs or both race to redeem the same link (Rollbar #534). -->
          @if (completingEmailLink) {
            <p class="login-completing">Signing you in…</p>
          } @else {
            <fui-email-link-auth-form
              (signIn)="onLoginSuccessful($event)">
            </fui-email-link-auth-form>
          }
        </div>
      }
    </div>
    <p class="flex-row justify-center align-center">
      <a routerLink="." (click)="whereIsFacebookDialog()">Where is "Sign in with Facebook"?</a>
    </p>
    <div style="font-size: 80%;">
      * If you have applied or participated in the past, please do not create a new account!
      If you cannot figure out how to sign in to your existing account, or you
      want to change the email or sign-in method for your account, contact
      admin&#64;terpeca.com.
    </div>
  </mat-card>
</section>
